var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useLazyQuery } from '@apollo/client/react';
import { ImportDocumentToCcsStatus } from 'shared/domains/apollo/generated/types';
import { ImportDocumentToCcsJobDocument } from './ImportDocumentToCcsJob.gql';
const POLL_INTERVAL_MS = 2000;
export const useGetImportDocumentToCcsJob = () => {
    const [query, result] = useLazyQuery(ImportDocumentToCcsJobDocument, {
        pollInterval: POLL_INTERVAL_MS,
        notifyOnNetworkStatusChange: true,
    });
    const startPollingJob = (jobId, onCompletedCallback) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const { data, error } = yield query({
                variables: { jobId },
            });
            if (error) {
                throw Error(error.message);
            }
            return onCompletedCallback((_a = data === null || data === void 0 ? void 0 : data.importDocumentToCcsJob) === null || _a === void 0 ? void 0 : _a.status);
        }
        catch (_b) {
            return onCompletedCallback(ImportDocumentToCcsStatus.Failed);
        }
    });
    const stopPollingJob = () => result.stopPolling();
    return { startPollingJob, stopPollingJob };
};
